var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
const TabContentStyle = styled.div `
    display: ${props => props.visible ? 'flex' : 'none'};
    font-family: ${props => props.theme.fonts.fontFamily};
    margin-top: ${props => props.theme.paddingsMargins.themeMenuMarginSingle};
    padding: ${props => props.theme.paddingsMargins.themeMenuPadding};
`;
const TabContent = (_a) => {
    var { value = 0, index = 0, isNotRender = false, children } = _a, props = __rest(_a, ["value", "index", "isNotRender", "children"]);
    return isNotRender
        ? value === index
            ? _jsx(TabContentStyle, Object.assign({ visible: true }, props, { children: children }))
            : _jsx(_Fragment, {})
        : _jsx(TabContentStyle, Object.assign({ visible: value === index }, props, { children: children }));
};
export default TabContent;
